import { useAuth } from "hooks/Auth";
import React from "react";

export default function DocsPanel(props) {
    const auth = useAuth();

    return (
        <div className="flex h-full w-full flex-col">
            <div className="flex-grow overflow-auto p-4">
                <div className="w-full space-y-8">
                    <p className="prose text-sm">
                        SNworks provides a number of documents that my be
                        required by your parent institution. If you have any
                        questions, please let us know!
                    </p>
                    <div>
                        <dt className="text-base font-medium text-gray-900">
                            Site Tag Sheet
                        </dt>
                        <dd className="mt-3 space-y-4 text-sm text-gray-500">
                            <p className="prose text-sm">
                                Tag sheets are generated by SNworks for every
                                site revision. Tag sheets help you determine
                                content placement on your site.
                            </p>
                            <ul className="mt-4 list-inside list-disc">
                                <li>
                                    <a
                                        href={`https://static.getsnworks.com/downloads/tag-sheets/${auth.publication.client_code}-latest.pdf`}
                                        className="text-green-700 underline"
                                    >
                                        {auth.publication.name} Tag Sheet -
                                        Latest
                                    </a>{" "}
                                    (PDF)
                                </li>
                            </ul>
                        </dd>
                    </div>
                    <div>
                        <dt className="text-base font-medium text-gray-900">
                            SNworks Site and Authoring VPAT<sup>&copy;</sup>
                        </dt>
                        <dd className="mt-3 space-y-4 text-sm text-gray-500">
                            <p className="prose text-sm">
                                VPATs are voluntary accessibility conformance
                                reports that may be required by your parent
                                institution.
                            </p>
                            <ul className="mt-4 list-inside list-disc">
                                <li>
                                    <a
                                        href="https://static.getsnworks.com/downloads/VPAT-2.4-2022-SNworks.pdf"
                                        className="text-green-700 underline"
                                    >
                                        VPAT 2.4 - Updated Mar 2022
                                    </a>{" "}
                                    (PDF)
                                </li>
                                <li>
                                    <a
                                        href="https://static.getsnworks.com/downloads/VPAT-2.0-2020-SNworks.pdf"
                                        className="text-green-700 underline"
                                    >
                                        VPAT 2.0 - Updated Oct 2020
                                    </a>{" "}
                                    (PDF)
                                </li>
                            </ul>
                        </dd>
                    </div>{" "}
                </div>
            </div>
        </div>
    );
}
